import { TDependantFieldsHydratedFragment, TRecipientFieldsFragment } from '../../generated/graphql';

export const isDependant = (recipient: TRecipientFieldsFragment): recipient is TDependantFieldsHydratedFragment => {
  return (recipient as TDependantFieldsHydratedFragment).employeeId != null;
};
